import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, InputAdornment, Typography } from '@mui/material';

import { ButtonUI, DialogUI, FormLabelUI, InputUI } from '../Interface';
import itemService from '../../service/item.service';
import { downloadFile, printFromResponse } from '../../utils/download';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';

const ItemBatchLabelDialog = (props) => {
  const { open, onClose, selectedValuesState, initialBatch, readonlyBatch, templateKey } = props;

  const { selectedValues } = selectedValuesState;

  const label = 'Cikk sarzs címke';

  const defaultData = {
    batch: '',
    labelQuantity: 1,
  };

  const [dialogData, setDialogData] = useState(defaultData);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    if (open) {
      setDialogData({ ...defaultData, batch: initialBatch ?? '' });
    }
  }, [open, initialBatch]);

  const handleGenerate = () => {
    if (!selectedValues?.itemCode) return;

    setGenerating(true);
    itemService
      .generateBatch(selectedValues.itemCode)
      .then((data) => {
        setDialogData((prev) => ({ ...prev, batch: data?.batch ?? data ?? '' }));
      })
      .finally(() => {
        setGenerating(false);
      });
  };

  const handlePrintClick = async () => {
    const printData = {
      key: templateKey ?? null,
      itemCode: selectedValues?.itemCode ?? '',
      itemName: selectedValues?.itemName ?? '',
      quantity: 1,
      unitPrice: 0,
      qtyUnit: selectedValues?.quantityUnit?.code ?? '',
      barCode: selectedValues?.barCode ?? '',
      batch: dialogData.batch,
      labelQuantity: dialogData.labelQuantity,
    };

    const response = await itemService.createLabel(printData);

    if (window.nativePrint) {
      printFromResponse(response, response.filename, printData.labelQuantity);
      return;
    }

    downloadFile(response, response.filename);

    addNotification({
      content: 'Címke nyomtatás elindítva',
      type: NotificationType.SUCCESS,
    });
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={label} maxWidth="md" fullWidth>
      <Grid container spacing={1} mt={1} sx={{ background: '#E9F5FE', borderRadius: '4px', p: '0.5rem' }}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Cikkszám
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{selectedValues?.itemCode}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Cikknév
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{selectedValues?.itemName}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1} p={1}>
        <Grid item xs={12} md={6}>
          <InputUI
            name="batch"
            label={<FormLabelUI text="Sarzs" />}
            type="text"
            value={dialogData.batch}
            variant="standard"
            onChange={(e) => setDialogData({ ...dialogData, batch: e.target.value })}
            disabled={readonlyBatch}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} display="flex" alignItems="center" justifyContent="center">
          {!readonlyBatch && (
            <ButtonUI
              text={generating ? <CircularProgress size={18} color="inherit" /> : 'Generálás'}
              className="bg-warning"
              onClick={handleGenerate}
              disabled={generating || !selectedValues?.itemCode}
            />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <InputUI
            name="labelQuantity"
            label={<FormLabelUI text="Címke mennyiség" />}
            type="number"
            value={dialogData.labelQuantity}
            variant="standard"
            onChange={(e) => setDialogData({ ...dialogData, labelQuantity: e.target.value })}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">db</InputAdornment>,
            }}
          />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Nyomtatás" className="bg-success" onClick={handlePrintClick} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ItemBatchLabelDialog;
